// remove this when we fix the for.
/* eslint-disable jsx-a11y/label-has-for */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import './DatePickerInput.css';

class DatePickerInput extends Component {
  static defaultProps = {
    value: 0,
    label: '',
    required: false,
    description: '',
    errorText: '',
    className: '',
  };
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }
  /**
   * This isn't a callback for a standard change event,
   * this is being called from a custom function within the DatePicker component,
   * that sends the value as a date object or null.
   *
   * @param {* Date } selectedDate
   */
  handleChange(selectedDate) {
    const { id, onChange, onValidate } = this.props;
    const dateValue = selectedDate
      ? moment(selectedDate)
      // Remove time.
        .startOf('day')
        .unix()
      : 0;
    onChange(id, dateValue);
    onValidate(id, dateValue);
  }
  render() {
    const {
      id, name, value, label, required, description, errorText, className,
    } = this.props;
    const validClass = errorText !== '' ? 'invalid' : '';
    const minDate = moment().add(1, 'd');

    return (
      <div>
        <div className={className}>
          <label className="active" htmlFor={id}>
            {label}
            {required ? <span className="required">*</span> : null}
          </label>
          <DatePicker
            id={id}
            name={name}
            className={validClass}
            selected={value ? moment.unix(parseInt(value, 10)) : null}
            minDate={minDate}
            dateFormat="MM/DD/YYYY"
            onChange={this.handleChange}
            isClearable
            showMonthDropdown
            showYearDropdown
          />
          <i className="icon-date-picker" />
          {description !== '' ? <div className="field-description">{description}</div> : null}
          {errorText !== '' ? <div className="error-message">{errorText}</div> : null}
        </div>
      </div>
    );
  }
}

DatePickerInput.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool,
  // Date value as unix timestamp.
  value: PropTypes.number,
  description: PropTypes.string,
  errorText: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onValidate: PropTypes.func.isRequired,
};

export default DatePickerInput;



// WEBPACK FOOTER //
// ./src/components/formElements/DatePickerInput.js